module.exports = __webpack_public_path__ + "static/media/step1.541adfd2.svg";